import i18n from "@/i18n";

const channelInfo = () => ({
    "88888": i18n.t("zhiji.game.basicServices"),
    "88888.sdk": i18n.t("zhiji.channel.SDKSet"),
    "88888.sdk_login": i18n.t("zhiji.channel.SDKLogin"),
    "88888.m_guest": i18n.t("zhiji.channel.m_guest"),
    "88888.m_setting": i18n.t("zhiji.channel.m_setting"),
    "80001": i18n.t("zhiji.game.securityBase"),
    "80001.h5_block": i18n.t("zhiji.channel.H5Scenes"),
    "80001.h5_safety": i18n.t("zhiji.channel.H5Site"),
    "80002": i18n.t("zhiji.game.contentBase"),
    "80002.mobile": "Mobile",
    "80002.lite": "Lite"
});

// 渠道接口数据转换 [{label: xx, value: xxx, children:[]}]
export const setChannelData = (channel, robots) => {
    let newChannelData = [
        {
            label: i18n.t("zhiji.overview.allChannel"),
            value: "all"
        }
    ];

    for (let game in channel) {
        newChannelData.push({
            label: channelInfo()[game] || getRobotName(robots, game),
            value: channel[game].join(","),
            children: channelNode(game, channel[game])
        });
    }

    return newChannelData;
};

function channelNode(game, nodeData) {
    let ret = [];
    ret = nodeData.map(item => {
        return {
            label: channelInfo()[`${game}.${item}`] || item,
            value: item
        };
    });
    return ret;
}

function getRobotName(robots, gameId) {
    const robot = robots.find(r => r.gameId == gameId);
    return robot ? robot.robotName : gameId;
}
